import {
  FOLLOWERS_FETCH_REQUEST,
  FOLLOWERS_FETCH_SUCCESS,
  FOLLOWERS_FETCH_FAILURE,
} from "./actionTypes"

const INIT_STATE = {
  followers: [],
  loading: false,
  error: null,
}

const followersReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FOLLOWERS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };

    case FOLLOWERS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        followers: action.payload,
      };

    case FOLLOWERS_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default followersReducer;




